<template>
  <div
    class="send-email-confirmation-view"
    @keyup.enter="onEnterPressed"
  >
    <div class="floating-card">
      <div
        v-if="!showSuccessMessage"
        class="card-text"
      >
        Send Email Confirmation
      </div>
      <div
        v-show="showSuccessMessage"
        class="success-wrapper"
      >
        The confirmation email was sent successfully.
        Please check your inbox.
      </div>
      <TextInput
        v-if="!showSuccessMessage"
        v-model="emailAddress"
        label="Email"
        :required="true"
      />
      <div
        v-show="showErrorMessage"
        class="error-text"
      >
        {{ errorMessage }}
      </div>
      <div
        v-if="!showSuccessMessage"
        class="button-wrapper"
      >
        <LockingButton
          class="locking-button"
          :disabled="!formValid"
          :locked="loading"
          :text="'Send'"
          @click="sendEmailConfirmation"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import TextInput from '@/components/shared/TextInput.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { MiscellaneousService } from '@/services/miscellaneous.service'
import { HandleUserNeedingEmailConfirmationMessage } from '@/@types/messages/HandleUserNeedingEmailConfirmationMessage'
import LockingButton from '@/components/shared/LockingButton.vue'

export default defineComponent({
  name: 'SendEmailConfirmation',
  components: {
    LockingButton,
    TextInput
  },
  props: {
    email: {
      type: String,
      default: ''
    }
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    return {
      miscellaneousService
    }
  },
  data() {
    return {
      emailAddress: this.email,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      showSuccessMessage: false
    }
  },
  computed: {
    formValid(): boolean {
      return this.emailAddress.trim() !== ''
    }
  },
  methods: {
    onEnterPressed(): void {
      if (this.formValid)
        this.sendEmailConfirmation()
    },
    sendEmailConfirmation(): void {
      if (this.loading) return

      this.showErrorMessage = false
      this.errorMessage = ''
      this.loading = true

      const handleUserNeedingEmailConfirmationMessage = new HandleUserNeedingEmailConfirmationMessage(this.emailAddress)
      this.miscellaneousService.handleUserNeedingEmailConfirmation(handleUserNeedingEmailConfirmationMessage).then(() => {
        this.loading = false
        this.showSuccessMessage = true
      }).catch(() => {
        this.loading = false
        this.errorMessage = 'Something went wrong. Please try again.'
        this.showErrorMessage = true
      })
    }
  }
})
</script>

<style scoped lang="scss">

.send-email-confirmation-view {
  @include sac-floating-card-view;
}

</style>
